import getMobileDeviceStatisticsOperation from 'owa-service/lib/operation/getMobileDeviceStatisticsOperation';
import GetMobileDeviceStatisticsRequest from 'owa-service/lib/contract/GetMobileDeviceStatisticsRequest';
import GetMobileDeviceStatisticsResponse from 'owa-service/lib/contract/GetMobileDeviceStatisticsResponse';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';

export async function getMobileDeviceStatistics(): Promise<GetMobileDeviceStatisticsResponse> {
    let request: GetMobileDeviceStatisticsRequest = {
        Header: getJsonRequestHeader(),
        Options: {
            GetMailboxLog: false,
        },
    };

    let response: GetMobileDeviceStatisticsResponse = await getMobileDeviceStatisticsOperation(
        request
    );
    return response;
}
